import { render, staticRenderFns } from "./NovaTurmaRow.vue?vue&type=template&id=d713763c&scoped=true&"
import script from "./NovaTurmaRow.vue?vue&type=script&lang=js&"
export * from "./NovaTurmaRow.vue?vue&type=script&lang=js&"
import style0 from "./NovaTurmaRow.vue?vue&type=style&index=0&id=d713763c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d713763c",
  null
  
)

export default component.exports